import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

// Wallet
export function* getWalletTransaction() {
  yield takeEvery(actionTypes.GET_WALLET_TRANSACTION_LIST, function*(action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.getWalletTransactionList(action.data);

      if (response.data.success) {
        yield put(actions.getWalletTransactionListSuccess(response.data));
      } else {
        alert(response.data.message);
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
    }
  });
}

export function* getWalletPaymentCode() {
  yield takeEvery(actionTypes.GET_WALLET_PAYMENT_CODE, function*(action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.getPaymentCode();
      if (response.data.success) {
        yield put(actions.getWalletPaymentCodeSuccess(response.data));
      } else {
        alert(response.data.message);
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
    }
  });
}

export function* getRebateTransaction() {
  yield takeEvery(actionTypes.GET_WALLET_REBATE_LIST, function*(action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.getRebatTransactionList(action.data);

      if (response.data.success) {
        yield put(actions.getRebateTransactionSuccess(response.data));
      } else {
        alert(response.data.message);
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
    }
  });
}

// Top Up
export function* loadWalletTopUp() {
  yield takeEvery(actionTypes.LOAD_WALLET_TOP_UP, function*(action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.loadWalletTopUp(action.data);

      if (response.data.success) {
        // Redirect to Molpay
        document.write(response.data.data.html);
      } else {
        alert("Warning: Fail to top up. " + response.data.message);
        yield put(actions.loadWalletTopUpFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to top up."));
      yield put(actions.loadWalletTopUpFail());
      yield put(actions.disableLoading());
    }
  });
}

export default function* walletSaga() {
  yield all([
    fork(getWalletTransaction),
    fork(getWalletPaymentCode),
    fork(getRebateTransaction),
    fork(loadWalletTopUp)
  ]);
}
